import { Component, OnInit, Inject } from '@angular/core';
import { ComponentCommentModalComponent } from '../component-comment-modal/component-comment-modal.component';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../../../../shared/services/user.service';
import { UpdateInspectionCommentModel } from '../../models/interpretation.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-inspection-comment-modal',
  templateUrl: './inspection-comment-modal.component.html',
  styleUrls: ['./inspection-comment-modal.component.scss']
})
export class InspectionCommentModalComponent implements OnInit {
  private inspectionId: number;
  comment: string;
  savingComment: boolean = false;
  isInspector: boolean = false;
  isInterpreter: boolean = false;
  newComment : string='';

  constructor(private _dialogRef: MatDialogRef<ComponentCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _user: UserService) { }

  ngOnInit() {
    this.checkPermissions();
    this.inspectionId = this._data.inspectionId;
    this.comment = this._data.comment;
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case "Inspectors":
              this.isInspector = true;
              break;
            case "Interpreters":
            case "Super User":
            case "Administrator":
              this.isInterpreter = true;
              this.isInspector = true;
              break;
          }
        })
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  updateComment() {
    this.savingComment = true;
    this._interp.updateInspectionComment(this.inspectionId,this.newComment ? this.newComment: this.comment ).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
        this._dialogRef.close(true);
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.error(r.m_Item2);
      }
      this.savingComment = false;
    }, err => {
      this._notify.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ');
      console.error(err);
      this.savingComment = false;
    });
  }
  commentChanged(newComment:string){
  

    this.newComment = newComment
  }
}
